import './style.scss'
import { Slider } from '../../../js/components/Slider/Slider'

export default !function () {
  const block = document.querySelector('.career-stories-v1')

  if (!block) {
    return;
  }

  const sliderContainer = block.querySelector('.career-stories-v1__wrapper')
  const slides = sliderContainer.querySelectorAll('.career-stories-v1__item')
  const controls = sliderContainer.querySelector('.career-stories-v1__controls')
  const isInit = slides.length > 1

  const options = {
    wrapper: sliderContainer,
    lazy: true,
    settings: {
      spaceBetween: 8,
      effect: 'slide',
      loop: false,

      slideClass: 'career-stories-v1__item',
      wrapperClass: 'career-stories-v1__list',

      navigation: {
        nextEl: '.button-arrow--next',
        prevEl: '.button-arrow--prev'
      },

      breakpoints: {
        1280: {
          loop: true
        }
      },
    },
    modules: ['navigation', 'a11y'],
    initCondition: {
      sm: isInit,
      md: isInit,
      lg: isInit,
      xl: isInit
    },
    controls
  }

  new Slider(options).init()
}()
